class sliderCollection extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;

    this.initSlider();
    setTimeout(this.resizeFeaturedPicture.bind(this), 500);
    window.addEventListener("resize", this.resizeFeaturedPicture.bind(this));

    this.addEventListener("reload", () => {
      this.swiper.destroy();
      this.initSlider();
    });
  }

  initSlider() {
    if (this.dataset.enableSlider == "false") return;
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 16,
      cssMode: true,
      centerInsufficientSlides: true,
      preventClicks: true,
      preventClicksPropagation: true,
      touchMoveStopPropagation: false,
      a11y: false,
      speed: 400,
      threshold: 15,
      navigation: {
        nextEl: this.querySelector(
          ".swiper-collection-product-container > .swiper-buttons .swiper-button-next"
        ),
        prevEl: this.querySelector(
          ".swiper-collection-product-container > .swiper-buttons .swiper-button-prev"
        ),
      },
      breakpoints: {
        989: {
          cssMode: false,
        },
      },
    });
  }

  resizeFeaturedPicture() {
    if (this.querySelector(".slider-collection__featured__image")) {
      this.querySelector(".slider-collection__featured__image").style.height =
        this.querySelector(".product-card__media").getBoundingClientRect()
          .height + "px";
    }
  }
}

customElements.define("slider-collection", sliderCollection);
